import React from 'react';
import API_BASE_URL from '../config';

const DebugConfig: React.FC = () => {
    const testConnection = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/health`);
            const data = await response.json();
            alert(`Success! API URL: ${API_BASE_URL}\nResponse: ${JSON.stringify(data)}`);
        } catch (error) {
            alert(`Failed! API URL: ${API_BASE_URL}\nError: ${error}`);
        }
    };

    return (
        <div style={{ padding: '20px', fontFamily: 'monospace' }}>
            <h1>Debug Configuration</h1>
            <div style={{ background: '#f0f0f0', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
                <p><strong>API_BASE_URL:</strong> {API_BASE_URL}</p>
                <p><strong>REACT_APP_API_URL:</strong> {process.env.REACT_APP_API_URL || 'Not set'}</p>
                <p><strong>NODE_ENV:</strong> {process.env.NODE_ENV}</p>
            </div>
            <button
                onClick={testConnection}
                style={{
                    padding: '10px 20px',
                    fontSize: '16px',
                    background: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                }}
            >
                Test API Connection
            </button>
        </div>
    );
};

export default DebugConfig;
